interface Config {
    defaultProvider: AllowedProvider;
    defaultModel: string;
    defaultAuth: 'none' | 'bearer-token' | 'api-key';
    defaultBase: string;
    defaultVersion: string;
    defaultKey: string;
    availableProviders: Provider[];
    availableModels: { [providerValue: string]: AvailableModel[] };
    writingCharacters: WritingCharacter[];
    writingTones: string[];
    writingStyles: string[];
    writingFormats: WritingFormat[];
    showDownloadLink: boolean;
    allowDarkModeToggle: boolean;
    allowSettingsModal: boolean;
    allowDatabaseModal: boolean;
    showTwitterLink: boolean;
    showFeedbackLink: boolean;
}

interface AvailableModel {
    value: string;
    label: string;
}
  
interface WritingCharacter {
    label: string;
    value: string;
}
  
interface WritingFormat {
    value: string;
    label: string;
}

// Define the Provider interface
interface Provider {
    value: string;
    label: string;
}

// Define allowed provider values explicitly
type AllowedProvider = 'openai' | 'custom' | 'anthropic' | 'google';

// --- Import the JSON data directly ---
import configData from '../static/config.json';

// --- Initialize config directly from imported data ---
export const config: Config = configData as Config;
